export default (el, selector) => {
    let node = el.parentNode;

    while (node && node !== node.parentNode) {
        if (typeof node.matches === 'function' && node.matches(selector)) {
            return node;
        }

        node = node.parentNode;
    }

    return false;
};
